export default __webpack_public_path__ + "static/media/Production.e1c86252.png";